'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { usePathname } from 'next/navigation';

import { Reference } from '@eliadmin/core/src/api/references/references-types';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { FooterReferences } from '../footer/_components/footer-refences';
import { CustomHeading } from './custom-heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const CustomFooterReferences = ({
  references,
  referencesSubtitle,
  referencesTitle,
}: {
  references: Reference[];
  referencesSubtitle: string;
  referencesTitle: string;
}) => {
  const locale = useLocaleStore(s => s.currentLocale);
  const pathname = usePathname();
  const { t } = useTranslations();

  function referenceByLocale(locale: string): string {
    const urlMap: { [key: string]: string } = {
      sk: '/referencie',
      en: '/references',
      de: '/verweise',
    };
    return `${urlMap[locale] || urlMap['sk']}`;
  }

  const referenceUrl = referenceByLocale(locale);

  function contactByLocale(locale: string): string {
    const urlMap: { [key: string]: string } = {
      sk: '/kontakt',
      en: '/en/kontakt',
      de: '/de/kontakt',
    };
    return `${urlMap[locale] || urlMap['sk']}`;
  }

  const contactUrl = contactByLocale(locale);

  return (
    <>
      {pathname !== contactUrl && (
        <section
          className={cn(
            '',
            pathname === referenceUrl ? 'ea-references__section--empty' : 'ea-references__section',
          )}
        >
          {pathname !== referenceUrl && (
            <>
              <CustomHeading subtitle={referencesSubtitle} title={referencesTitle}>
                <Image
                  src={'/images/underline.svg'}
                  alt={t('text1000')}
                  width={0}
                  height={0}
                  className={cn('ea-references__underline')}
                />
              </CustomHeading>
              <FooterReferences references={references} />
              <div className="flex w-full items-center justify-center px-4">
                <Button asChild>
                  <Link href={referenceUrl}>{t('text799')}</Link>
                </Button>
              </div>
            </>
          )}
        </section>
      )}
    </>
  );
};
